import { withStyles } from '@material-ui/core';
import { ChatOutlined } from '@material-ui/icons';
import ToolTip from '../../../../../common/StyledToolTip';
import styles from './styles';

const MsgHistory = ({ classes, onClick }) => {
  return (
    <div className={classes.scHeaderCloseButton} onClick={onClick}>
      <ToolTip title="Msg History">
        <ChatOutlined className={classes.scHeaderMsgIcon} />
      </ToolTip>
    </div>
  );
};

export default withStyles(styles)(MsgHistory);
